import React from "react";
import { CheckIcon } from "lucide-react";
import { QuestionStep } from "../types/quiz";
import { DigestionEffortVisual } from "./DigestionEffortVisual";
import { AgeInput } from "./AgeInput";
interface QuestionScreenProps {
  step: QuestionStep;
  selected?: string;
  onSelect: (optionId: string) => void;
}
export function QuestionScreen({
  step,
  selected,
  onSelect
}: QuestionScreenProps) {
  return <section className="mx-auto max-w-2xl px-4 py-8 sm:px-6 md:py-12" aria-labelledby={`${step.id}-title`} data-id="element-278" data-mp="298aoadkug6z">
      {step.image && <img src={step.image} alt="" className="mb-6 aspect-[16/9] w-full rounded-2xl object-cover object-center" data-id="element-279" data-mp="3tdybc09ld3sj" />}
      {step.visual === "digestion" && <div className="mb-6" data-id="element-280" data-mp="3kfcuc9jrpwtv">
          <DigestionEffortVisual data-id="element-281" data-mp="3kgfmslwqo7bw" />
        </div>}
      <h2 id={`${step.id}-title`} className="font-serif text-2xl font-semibold leading-tight text-cocoa sm:text-3xl" data-id="element-282" data-mp="1nmulvp8oxc0e">
        {step.title}
      </h2>
      {step.hint && <p className="mt-3 text-base italic text-olive-700" data-id="element-283" data-mp="1ildo42li65o1">{step.hint}</p>}

      {step.input === "age" && <AgeInput labelledBy={`${step.id}-title`} initial={selected} onSubmit={onSelect} data-id="element-284" data-mp="3sld0lb45t98q" />}

      {!step.input && <div role="radiogroup" aria-labelledby={`${step.id}-title`} className="mt-7 space-y-3" data-id="element-285" data-mp="3jibu39bdtg4j">
        {step.options.map(option => {
        const isSelected = selected === option.id;
        return <button key={option.id} type="button" role="radio" aria-checked={isSelected} onClick={() => onSelect(option.id)} className={`flex w-full items-center gap-4 rounded-2xl border-2 px-4 py-4 text-left text-base font-medium transition-[background-color,border-color,transform] duration-150 ease-out active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-400 sm:px-5 sm:text-lg ${isSelected ? "border-rose-600 bg-blush-50 text-cocoa" : "border-blush-100 bg-white text-cocoa hover:border-blush-200 hover:bg-blush-50"}`} data-id="element-286" data-mp="g1vbca9gmw4u">
              <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors duration-150 ${isSelected ? "bg-rose-600 text-white" : "bg-cream-dark text-cocoa-soft"}`} aria-hidden="true" data-id="element-287" data-mp="18ntpv8g6lxdm">
                {isSelected ? <CheckIcon className="h-4 w-4" data-id="element-288" data-mp="upn1qk11bbr5" /> : option.id}
              </span>
              <span data-id="element-289" data-mp="pw0w3btag84u">{option.label}</span>
            </button>;
      })}
      </div>}
    </section>;
}